import { COMMON_PAGE_TEXT } from '../../../../components/lang';

export const PAGE_TEXT = {
  ...COMMON_PAGE_TEXT,
  PAGE_TITLE: 'Create Application',
  TITLE: 'Create Application',
  OTHER_TEST: 'Other Test',
  SUPPORTING_DOCUMENTS: 'Supporting Documents',
  APPLICATION_PROGRESS: 'Application Progress',
  PROGRAMME: {
    HYPER_LINK: `For potential PhD supervisor, please refer to the 
    <a href='https://www.polyu.edu.hk/study/pg/research-postgraduate' target="_blank" rel="noopener noreferrer">e-prospectus</a> 
    and the <a href='https://www.polyu.edu.hk/gs/prospective-students/find-a-supervisor/' target="_blank" rel="noopener noreferrer">website(s) of department.</a>`,
    TITLE: 'Programme',
    FULL_TIME: 'Full-time',
    PART_TIME: 'Part-time',
    ONLINE: 'Online',
    MASTER_OF_PHILOSOPHY: 'Master of Philosophy',
    DOCTOR_OF_PHILOSOPHY: 'Doctor of Philosophy',
    GENERAL_PROGRAMME: 'General Programme',
    DUAL_PHD_DEGREE_PROGRAMME: 'Dual PhD Degree Programme',
    JOINT_PHD_DEGREE_PROGRAMME: 'Joint  PhD Degree Programme',
    SPONSORED_PHD_PROGRAMME: 'Sponsored PhD Programme',
    // Mod meeting 2024/8/2
    COLLABORATIVE_PHD_DEGREE_PROGRAMME:
      'Joint PhD Supervision Programs Leading to a PolyU Degree',

    IS_DUAL_OR_COLLABORATIVE_PROGRAMME:
      'Do you intend to apply for a Dual PhD Degree Programmes / Joint PhD Supervision Programmes Leading to a PolyU Degree?',
    ENTRY_YEAR: 'Entry Year/Semester',
    MODE_OF_STUDY: 'Mode of Study',
    DEPARTMENT: 'Department',
    PROGRAMME: 'Programme',
    PROGRAMME_TYPE: 'Programme Type',
    RESEARCH_AREA: 'Research Area',
    RESEARCH_AREA_OPTIONAL: 'Research Area 2',
    PARTNER_INSTITUTION: 'Name of Partner University/Institution',
    UNIVERSITY_CATEGORY: 'Partner University/Institution Category',
    IS_POLYU_HOME: 'PolyU is Home University',
    PROPOSED_CHIEF_SUPERVISOR_OF_PARTNER_INSTITUTION:
      'Proposed Chief Supervisor of Partner University/Institution',
    APPLICATION_NO_OF_PARTNER_INSTITUTION:
      'Application No. of Partner University/Institution',
    PROPOSED_CHIEF_SUPERVISOR: 'Proposed Chief Supervisor',
    PROPOSED_SUPERVISOR_TIPS:
      'You may be assigned to other Chief Supervisors based on departmental resources.',
    PROPOSED_CHIEF_SUPERVISOR_OPTIONAL: 'Proposed Chief Supervisor 2',
    INTEND_TO_ACCEPT_OFFER:
      'Do you intend to accept offer if no research studentship is provided?',
    FROM: 'From',
    TO: 'To',
    STUDY_PERIOD_FROM_SEMESTER: 'Study Period From Semester',
    STUDY_PERIOD_TO_SEMESTER: 'Study Period To Semester',
    STUDY_PERIOD_FROM_ACADEMIC_YEAR: 'Study Period From Academic Year',
    STUDY_PERIOD_TO_ACADEMIC_YEAR: 'Study Period To Academic Year',
    SEMESTER_ONE: 'Semester one',
    SEMESTER_TWO: 'Semester two',
    SUMMER_TERM: 'Summer Term',
    CHINA_MAINLAND: 'Chinese Mainland',
    OVERSEAS: 'Overseas',
  },
  PROGRAMME_CHOICE: {
    TITLE: 'Programme',
    FORM: {
      ENTRY_LEVEL: 'Entry Level',
      MODE_OF_STUDY: 'Mode of Study',
      DEPARTMENT: 'Department',
      PROGRAMME: 'Programme',
      PROGRAMME_TYPE: 'Programme Type',
      RESEARCH_AREA: 'Research Area',
      PARTNER_UNIVERSITY: 'Partner University/Institution',
      PARTNER_PROPOSED_CHIEF_SUPERVISOR:
        'Proposed Chief Supervisor for Partner University/Institution',
      PARTNER_STUDY_PERIOD_FROM: 'Study Period in Partner University From',
      PARTNER_STUDY_PERIOD_TO: 'Study Period in Partner University To',
      PROPOSED_SUPERVISOR: 'Proposed Supervisor',
      INTEND_TO_ACCEPT_OFFER:
        'Do you intend to accept offer if no research studentship is provided?',
      SAVE: 'Save',
    },
    OPTIONS: {
      SEMESTER2_2023: '2023 Semester 2 (Jan 2024 Entry)',
      SUMMER_TERM_2023: '2023 Semester Term (May 2024 Entry)',
      MPHIL: 'Master of Philosophy',
      PHD: 'Doctor of Philosophy',
      GENERAL_PROGRAMME: 'General Programme',
      DUAL_PHD_DEGREE_PROGRAMME: 'Dual PhD Degree Programme',
      SPONSORED_PHD_PROGRAMMES: 'Sponsored PhD Programmes',
      NO_INDICATION: 'Not Indicated / Not Applicable',
    },
    ALERT_TEXT: {
      SAVE_SUCCEED: 'Saved Programme Choice Successfully.',
      SAVE_FAILED: 'Save Programme Choice Failed',
      CONFLICT:
        'You have already created an application for the same entry year and the same programme under this department.',
      INVALID_USER:
        'The account currently in use is invalid. Please contact our support team at gs.it@polyu.edu.hk.',
    },
  },
  FELLOWSHIP: {
    TITLE: 'Fellowship & Scholarship',
    RECOMMEND_PPPFS: `The application deadline is 1 December 2024 23:59 HKT. You are strongly encouraged to apply for the <a href="https://www.polyu.edu.hk/gs/prospective-students/polyu-presidential-phd-fellowship-scheme/" target="_blank">PolyU Presidential PhD Fellowship Scheme (PPPFS)</a> in addition to the HKPFS. By applying to both, you maximize your opportunities and enhance your chances of receiving support for your studies.`,
    DISTINCTIVE_TIPS: `Application for the Second round of Distinctive Scholarships (PPPFS and IPFS) is now open. Second round Application period: 10 March 2025 00:00 HKT to 1 April 2025 23:59 HKT (GMT +8 hours). Only applications for 2025/26 Semester Two can apply for the Second Round of the PPPFS and IPFS. `,
    DISTINCTIVE_HELPERTEXT: `<p>Eligibility criteria, scholarship packages and other information are available on the GS websites: 
<a href="https://www.polyu.edu.hk/gs/prospective-students/fellowship-scholarship-schemes/pppfs/" target="_blank">PolyU Presidential PhD Fellowship Scheme (PPPFS)</a> and
<a href="https://www.polyu.edu.hk/gs/prospective-students/fellowship-scholarship-schemes/ipfs/" target="_blank">International PhD Fellowship Scheme (IPFS)</a>.</p>`,
    DISTINCTIVE_REMINDER:
      'Please make sure you meet the eligibility of the scholarship prior to proceeding with your application.',
    HKPFS: {
      TITLE: 'HKPFS',
      HKPFS_NAME: 'Hong Kong PhD Fellowship Scheme (HKPFS)',
      APPLY_HKPFS: 'Apply for HKPFS?',
      HKPFS_REFERENCE_NUMBER: 'HKPFS Reference Number',
      APPLY_HKPFS_NOTICE: `If you do not have a HKPFS reference number, please go to the Research Grants Council (RGC) through its <a href="https://cerg1.ugc.edu.hk/hkpfs/InitApplication.jsp" target="_blank">HKPFS System</a> to obtain an HKPFS reference number.`,
      APPLICATION_GUIDE: `<a href="https://www.polyu.edu.hk/gs/prospective-students/hkpfs/application/" target="_blank">Application Guide and Tips</a>`,
    },
    DISTINCTIVE_SCHOLARSHIP: {
      TITLE: 'Distinctive Scholarship',
      INDICATION:
        'Please indicate the Distinctive Scholarships you would like to apply and priority them. ',
      APPLY_HKPFS_INDICATION: 'You must apply for HKPFS if you apply for this.',
      FIRST_PRIORITY: 'First priority:',
      SECOND_PRIORITY: 'Second priority:',
      REASON_EXPLANATION: 'Justification for scholarship consideration:',
      PROOF_DOCUMENT: 'Proof Document',
    },
  },
  QUALIFICATION: {
    TITLE: 'Qualification',
    CONDITION_MEET: 'Go to Submit',
    LANGUAGE_QUALIFICATION: {
      TITLE: 'Language Qualification',

      TEST_REPORT_FORM_NO: 'Test Report Form Number',
      APPOINTMENT_NO: 'Appointment Number',
      OPTIONS_LABEL: {
        LANGUAGE_QUALIFICATION_TEST_TYPE: {
          IELTS: 'International English Language Testing System (IELTS)',
          TOEFL:
            'Test of English as a Foreign Language (TOEFL) - Internet based',
        },
        SCORE_RANGE: {
          IELTS: '0-9',
          TOEFL: '0-30',
          TOEFLTOTAL: '0-120',
        },
      },
      NEED_ENGLISH_TEST: 'Need English Test',
      ENGLISH_UNIVERSITY:
        'Do/Will you have a degree for which English was/is the language of instruction at a recognized university?',
      HAVE_VALID_RESULT: 'Do you have valid English test result(s) now?',
      TEST_TYPE: 'Test Type',
      TEST_DATE: 'Test Date',
      RESULT_RECEIPT_DATE: 'Date of Result Receipt',
      EXPECTED_UPDATE_DATE: 'Expected Update Date',
      LANGUAGE_QUALIFICATION: 'Language Qualification',
      TEST_RESULT_ANNOUNCED: 'Test Result Announced?',
      I_WILL_UPDATE_RESULT_AT: 'I will update result by',
      LISTENING: 'Listening',
      READING: 'Reading',
      SPEAKING: 'Speaking',
      WRITING: 'Writing',
      OVERALL_BAND_SCORE: 'Overall Band Score',
      TOTAL_SCORE: 'Total Score',
      CERTIFICATE: 'Certificate(s)',
      TRANSCRIPT: 'Transcript(s)',
      SUPPORTING_DOCUMENTS: 'Supporting Documents',
      OTHER_DOCUMENTS: 'Other Documents',
    },
    ACADEMIC_QUALIFICATION: {
      TITLE: 'Academic Qualification',
      FORM_HELPER_TEXT: 'List the most recent degree first.',
      HELPER_TEXT: {
        OUT_OF:
          'The highest point of GPA/mark varies from different institutions/countries, you will normally find the information of the grading system in the legend of certificate/transcript.',
        NO_CGPA:
          'Please calculate the Award/Cum. GPA or Avg Mark* by using the GPA/Mark Calculator:',
        CONVERTED_SCORE:
          'Please use the GPA converter to convert your GPA to the standard scale.',
      },
      LEVEL_OF_DEGREE: 'Level of Degree',
      NAME_OF_PROGRAMME_AWARD: 'Name of Programme/Award',
      PRESENT: 'Present studying qualification?',
      HAVE_CGPA: 'The transcript provides a Award/Cum. GPA or Avg Mark?',
      FROM: 'From',
      TO: 'To',
      MODE_OF_STUDY: 'Mode of Study',
      CURRENT_STUDY_YEAR: 'Current Study Year',
      NAME_OF_INSTITUTION: 'Name of Institution',
      COUNTRY_REGION_OF_INSTITUTION: 'Country/Region of Institution',
      MEDIUM_OF_INSTRUCTION: 'Medium of Instruction',
      OTHER_MEDIUM: 'Other Medium of Instruction',
      FIELD_OF_STUDY: 'Field of Study',
      MEDIUM_OF_QUALIFICATION: 'Means of Qualification',
      QUALIFICATION_STATUS: 'Qualification Status',
      HAVE_ACADEMIC_CREDENTIAL: 'I have Academic Credential(畢業證書)',
      ACADEMIC_CREDENTIAL_INTRO: `For Graduation Certificate: Please obtain the Online Verification Code for Qualification Certificate (学历证书在线验证码) issued by <a href="https://www.chsi.com.cn/xlcx/bgys.jsp" target="_blank" rel="noreferrer">the China Higher Education Student Information (CHSI) (中国高等教育学生信息网)</a> and extend the validity for verification.`,
      HAVE_DEGREE_CERTIFICATE: 'I have Degree Certificate(學士學位證書)',
      DEGREE_CERTIFICATE_INTRO: `For Degree Certificate: Please obtain the the Online Verification Code (学位证书在线验证码) issued by <a href="https://www.chsi.com.cn/xlcx/bgys.jsp" target="_blank" rel="noreferrer">the China Higher Education Student Information (CHSI) (中国高等教育学生信息网)</a> and extend the validity for verification.`,
      ONLINE_VERIFICATION: 'Online Verification Code(在綫驗證代碼)',
      DEGREE_VERIFICATION: 'Degree Cert Online Verification Code(在綫驗證碼)',
      DATE_OF_AWARD: 'Date of Award',
      AWARD_CLASSIFICATION: 'Award Classification',
      WITHDRAWAL_DATE: 'Date of Withdrawal',
      EXPECTED_DATE: 'Expected Graduate Time',
      OFFICIAL_MARK: 'Official Mark/GPA',
      NO_OFFICIAL_MARK_GPA:
        'No transcript will be issued by the institution. I will upload an official proof.',
      AWARD_CUM_GPA_AVG_MARK: 'Award/Cum. GPA or Avg Mark',
      CONVERTED_SCORE: 'Converted Score (Based on 4.0)',
      NO_OFFICIAL_RANK: 'No Official Rank in Class',
      RANK_IN_CLASS: 'Rank in Class',
      RANK: 'Rank',
      OUT_OF: 'Out of',
      ADD_MORE_FORM: 'Add More Academic Qualifications',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        CERTIFICATE: 'Certificate(s)',
        TRANSCRIPT: 'Latest Transcript(s)/Official Proof',
        SYSTEM_EXPLANATION:
          'Explanatory Notes of the Marking Scheme/Grading System',
        SYSTEM_EXPLAIN_TOOLTIPS:
          'If there is no grading system, please upload official documentation as proof.',
        RANKING_PROOF: 'Rank in Class',
        OTHER_DOCUMENTS: 'Other Documents',
        UPLOAD_TRANSCRIPT_HINT:
          'Please upload Latest Transcript(s)/Official Proof. ',
        UPLOAD_MARK_EXPLAIN:
          'Please upload Explanatory Notes of the Marking Scheme/Grading System. ',
        UPLOAD_CERTIFICATE_HINT: 'Please upload Certificate(s) of the degree.',
        UPLOAD_CLASS_RANK_HINT: 'Please upload Proof of Ranking in Class.',
        UPLOAD_CERTIFICATE_ALERT:
          'Your academic certificate must include the official stamp/seal and authorized signature from your institution. Documents without these official markings will be considered invalid and cannot be accepted for your application.',
        UPLOAD_TRANSCRIPT_ALERT:
          'Your academic transcript/proof must include the official stamp/seal and authorized signature from your institution. Documents without these official markings will be considered invalid and cannot be accepted for your application.',
        UPLOAD_EXPLANATORY_NOTE_ALERT:
          'It is usually printed on the back page of the transcripts with the definition of key terms or abbreviations used, explanation of the grading scale or system used, definition of award/honour classifications, and the calculation method of marks/GPA. If not applicable, please upload an official proof of no marking/grading system.',
        UPLOAD_RANKING_PROOF_ALERT:
          'The proof must include the official stamp/seal and authorized signature from your institution. Documents without these official markings will be considered invalid and cannot be accepted for your application.',
      },
      FILES_INDEX: {
        CERTIFICATE: 'certificates',
        TRANSCRIPT: 'transcripts',
        SYSTEM_EXPLANATION: 'markExplanations',
        RANKING_PROOF: 'classRankProofs',
        OTHER_DOCUMENTS: 'otherDocuments',
      },
      GPA_DIALOG: {
        RECORD: 'Applicant Record',
        WARNING_TIPS: 'Please input the result of ALL courses.',
        HELPER_PAGE: 'For more information about the GPA type, please click ',
        DIALOG_V1_TITLE: 'GPA/Mark Calculator',
        DIALOG_V2_TITLE: 'GPA/Mark Convertor',
        GPA_TYPE: 'GPA Type',
        GPA_TYPE_OPTIONS: {
          CGPA: 'Cumulative Grade Point Average (CGPA)',
          AVERAGE_MARK: 'Average Mark',
          AVERAGE_GRADE: 'Average Grade',
        },
        COURSE_NAME: 'Course Name',
        CREDITS: 'Credits',
        RESULT: 'Result',
        ADD_MORE_COURSE: 'Add More Course Results',
        NON_APPLIED_HINT:
          'You indicate there is no matched rule applicable to your case. Please ensure to upload the transcript and marking scheme of your academic qualification.',
        ORIGINAL_GPA: 'Award/Cum. GPA or Avg Mark',
        OUT_OF: 'out of',
        AVE_SCORE: 'Converted Score',
        CONVERTED_GPA: 'Converted Score (Based on 4.0)',
        SELECTED_RULE: 'Conversion Rule',
        CONVERT_RULE: 'Conversion Rule(s)',
        NOTE: 'Note: ',
        RULE_DETAIL: 'Rule Detail: ',
      },
    },
    OTHER_TEST: {
      TITLE: 'Other Test',
      ADD_MORE_FORM: 'Add More Other Tests',
      HELPER_TEXT_NOTE:
        '(Note: You must update the results before the commencement of the study.)',
      REFERENCE_NO: 'Reference Number',
      TEST_TYPE: 'Test Type',
      TEST_DATE: 'Test Date',
      RESULT_RECEIPT_DATE: 'Date of Result Receipt',
      TEST_RESULT_ANNOUNCED: 'Test Result Announced?',
      I_WILL_UPDATE_RESULT_AT: 'I will update result at',
      TOTAL: 'Total',
      QUANTITATIVE: 'Quantitative',
      QUANTITATIVE_REASONING: 'Quantitative Reasoning',
      ANALYTICAL_WRITING: 'Analytical Writing',
      DATA_INSIGHTS: 'Data Insights',
      VERBAL: 'Verbal',
      VERBAL_REASONING: 'Verbal Reasoning',
      INTEGRATED_REASONING: 'Integrated Reasoning',
      SCORE: 'Score',
      PERCENTILE: 'Percentile',
      CERTIFICATE: 'Certificate(s)',
      TRANSCRIPT: 'Transcript(s)',
      OTHER_DOCUMENTS: 'Other Documents',
      SCORE_RANGE: {
        GRE: {
          QUANTITATIVE: '130-170',
          QUANTITATIVEMIN: '130',
          QUANTITATIVEMAX: '170',

          VERBAL: '130-170',
          VERBALMIN: '130',
          VERBALMAX: '170',

          ANALYTICAL: '0-6',
          ANALYTICALMIN: '0',
          ANALYTICALMAX: '6',
        },
        GMAT: {
          QUANTITATIVE: '0-60',
          QUANTITATIVEMIN: '0',
          QUANTITATIVEMAX: '60',

          VERBAL: '0-60',
          VERBALMIN: '0',
          VERBALMAX: '60',

          TOTAL: '200-800',
          TOTALMIN: '200',
          TOTALMAX: '800',

          ANALYTICAL: '0-60',
          ANALYTICALMIN: '0',
          ANALYTICALMAX: '60',

          INTEGRATED: '0-8',
          INTEGRATEDMIN: '0',
          INTEGRATEDMAX: '8',
        },
        GMAT_FOCUS: {
          DATA_INSIGHTS: '60-90',
          DATA_INSIGHTSMIN: '60',
          DATA_INSIGHTSMAX: '90',

          TOTAL: '205-805',
          TOTALMIN: '205',
          TOTALMAX: '805',

          QUANTITATIVE: '60-90',
          QUANTITATIVEMIN: '60',
          QUANTITATIVEMAX: '90',

          VERBAL: '60-90',
          VERBALMIN: '60',
          VERBALMAX: '90',
        },
      },
      OPTIONS_LABEL: {
        OTHER_TEST_TYPE: {
          GMAT_FOCUS:
            'Graduate Management Admission Test (GMAT) (Focus Edition)',
          GMAT_ONLINE: 'Graduate Management Admission Test (GMAT) (Online)',
          GMAT: 'Graduate Management Admission Test (GMAT)',
          GRE: 'Graduate Record Examinations (GRE)',
        },
      },
    },
    DIALOG_NOTE:
      'Please ensure that all required updates have been saved to secure your conditional offer. This is an important step, as it may influence the outcome of your final offer.',
  },
  OTHER_INFORMATION: {
    TITLE: 'Other Information',
    PART_A: 'Part A',
    PART_B: 'Part B',
    PART_C: 'Part C',
    STUDY_PLAN: {
      TITLE: 'Study Plan',
      UPLOAD_STUDY_PLAN: 'Please upload your Study Plan. ',
      TEMPLATE: `Download the <a style = "text-decoration: underline;" href = "https://www.polyu.edu.hk/gs/docdrive/forms/FormGSBJ4a.doc">study plan template here</a>. `,
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Study Plan',
      },
    },
    EXTRA_ACTIVITY: {
      TITLE: 'Extra Curricular Activities',
      PRESENT: 'Is it your present activity?',
      FROM: 'From',
      TO: 'To',
      ACTIVITY_TYPE: 'Activity Type',
      VOLUNTEER_MODE: ' Mode of Volunteer work/Community',
      ACTIVITY_TYPE_OPTIONS: {
        COMMUNITY_SERVICE: 'Volunteer Work/Community Services',
        EXTRACURRICULAR_ACTIVITY: 'Extracurricular Activities',
      },
      ORGANIZATION_NAME: 'Name of Organization',
      POSITION: 'Position Held/Nature of Business',
      MAJOR_RESPONSIBILITIES: 'Major Responsibilities',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Supporting document',
      },
      ADD_MORE_FORM: 'Add More Extracurricular Activities',
    },
    TRAINING: {
      TITLE: 'Training / Internship',
      PRESENT: 'Is it your present training/internship?',
      FROM: 'From',
      TO: 'To',
      COUNTRY: 'Country/Region',
      ORGANIZATION_NAME: 'Name of Organization',
      PROGRAMME: 'Name of Programme',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Supporting document',
      },
      ADD_MORE_FORM: 'Add More Training/Internship Experience',
    },
    RESEARCH_EXPERIENCE: {
      TITLE: 'Research Plan and Vision Statement',
      PAST_RESEARCH_EXPERIENCE:
        '1. Please provide your past experience or participation in research projects (max. 7,500 characters including spaces).',
      PROPOSED_RESEARCH_TOPIC:
        '2. Please provide your proposed research topic (max.500 characters including spaces).',
      PROPOSED_RESEARCH_PLAN:
        '3. Please provide your proposed research plan for doctoral research (max. 7,500 characters including spaces). The description should include the general field of the research; the specific research question(s) or project aims; the research methodology or approach; your experience, participation in research projects, or preliminary results that support the feasibility of the work (if applicable); the significance, originality and/or anticipated impact of the work.',
      REASONS:
        '4. Reasons for wishing to pursue PhD studies in Hong Kong (max. 2,000 characters including spaces).',
      LONG_TERM_CAREER_PLAN:
        '5. Long-term career plan, aims and interests for future development after graduation (max. 2,000 characters including spaces).',
      EXPECTED_CONTRIBUTION:
        '6. Contribution that you would like to make to the development of research in Hong Kong and to the society (max. 2,000 characters including spaces).',
      SCHOLARSHIP_OTHERS:
        '7. Other information in relation to the application for Fellowship & Scholarship (max. 2,000 characters including spaces), if applicable.',
      SCHOLARSHIP_OTHERS_NOTE: 'If not applicable, please input N/A.',
      HKPFS_OTHERS:
        '7. Other information in relation to the application for Hong Kong PhD Fellowship (max. 2,000 characters including spaces).',
      FILES_PANEL: {
        PANEL_TITLE: 'Research Experience',
        PANEL_CAPTION: 'Research Degree Proposal(GSB/1A)',
      },
    },
    EMPLOYMENT: {
      TITLE: 'Work Experience',
      PRESENT: 'Is it your present employment?',
      FROM: 'From',
      TO: 'To',
      MODE_OF_EMPLOYMENT: 'Mode of Employment',
      MODE_OF_EMPLOYMENT_OPTIONS: {
        FULL_TIME: 'Full-time',
        PART_TIME: 'Part-time',
      },
      FIELD_OF_EMPLOYMENT: 'Field of Employment',
      FIELD_OF_EMPLOYMENT_OPTIONS: {
        ACCOUNTING_AUDITING: 'Accounting/Auditing',
        ARCHITECTURE_SURVEYING: 'Architecture/Surveying',
        ADVERTISING_MARKETING: 'Advertising/Marketing',
        BANKING_FINANCE: 'Banking/Finance',
        BIOTECHNOLOGY_CHEMICALS: 'Biotechnology/Chemicals',
        BUILDING_CONSTRUCTION: 'Building/Construction',
        CIVIL_AND_SOCIAL_SERVICES: 'Civil and Social Services',
        COMMUNICATION_PUBLIC_RELATIONS: 'Communication/Public Relations',
        DESIGN: 'Design',
        EDUCATION: 'Education',
        ENGINEERING: 'Engineering',
        HEALTH_CARE: 'Health Care',
        HOTEL_CATERING: 'Hotel/Catering',
        INFORMATION_TECHNOLOGY: 'Information Technology',
        INSURANCE: 'Insurance',
        LEGAL: 'Legal',
        LOGISTICS_TRANSPORT: 'Logistics/Transport',
        MANUFACTURING: 'Manufacturing',
        MEDIA: 'Media',
        MERCHANDISING_TRADING: 'Merchandising/Trading',
        PRINTING_PUBLISHING: 'Printing/Publishing',
        PUBLIC_UTILITIES: 'Public Utilities',
        REAL_ESTATE: 'Real Estate',
        TELECOMMUNICATIONS: 'Telecommunications',
        TEXTILES_AND_GARMENTS: 'Textiles and Garments',
        TOURISM_TRAVEL: 'Tourism/Travel',
        WHOLESALE_AND_RETAIL: 'Wholesale and Retail',
        OTHERS: 'Others',
      },
      ORGANISATION_NAME: 'Name of Organization',
      POSITION: 'Job Position',
      MAJOR_RESPONSIBILITIES: 'Major Responsibilities',
      MAX_WORDS: 'Max 50 characters including spaces',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Supporting document',
      },
      ADD_MORE_FORM: 'Add More Work Experience',
    },
    PUBLICATION: {
      TITLE: 'Publication',
      PUBLICATION_ROLES: {
        FIRST_AUTHOR: '1st Author',
        SECOND_AUTHOR: '2nd Author',
        CORRESPONDING_AUTHOR: 'Corresponding Author',
        OTHER: 'Other',
      },
      PUBLICATION_TYPES: {
        JOURNAL_ARTICLE: 'Refereed Journal Article',
        CONFERENCE_PRESENTATION: 'Conference Presentation',
        CONFERENCE_PUBLICATION: 'Conference Publication',
        BOOK_CHAPTER: 'Book/Chapter in Book',
        PROFESSIONAL_MAGAZINE: 'Publication in Professional Magazine',
        NEWSPAPER: 'Publication in Newspaper',
        OTHER_PUBLICATION: 'Other Publication',
        EXHIBITION: 'Exhibition',
        PATENTS: 'Patents and Copyright',
        PUBLIC_ACQUISITION: 'Public Acquisition',
      },
      PUBLICATION_STATUSES: {
        PUBLISHED: 'Published',
        IN_PRESS: 'Not yet published - Accepted in press',
        UNDER_REVIEW: 'Not yet published - Under review',
        WRITING_IN_PROGRESS: 'Not yet published - Writing in progress',
      },
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Supporting documents',
      },
      FORM_LABELS: {
        TYPE: 'Publication Type',
        OTHER_TYPE: 'Specific Publication Type',
        NAME: 'Name of Journal/Conference/Publisher',
        TITLE: 'Publication Title',
        AUTHOR: 'Author(s)',
        ROLE: 'Role of the Applicant',
        ROLE_OTHER: 'Specify the Role',
        STATUS: 'Publication Status',
        DATE: 'Publication Date',
        ISSUE: 'Issue/Page/Article No.',
        REVIEWED: 'Peer-Reviewed?',
        CITATION: 'Citation Information',
        URL: 'URL of the Publication',
      },
      ADD_MORE_FORM: 'Add More Publications',
    },
    MERIT: {
      TITLE: 'Prize & Award (Merit)',
      MERIT_NAME: 'Name of Merit',
      FROM: 'From',
      TO: 'To',
      AWARD_DATE: 'Award Date',
      COUNTRY: 'Country/Region',
      AWARD_BODY_NAME: 'Name of Awarding Body',
      ATTAINMENT_MEANS: 'Means of Attainment',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Supporting Document',
      },
      ADD_MORE_FORM: 'Add More Merits',
    },
    ACADEMIC_REFEREE: {
      TITLE: 'Academic Referee',
      REFEREE_TITLE: 'Title',
      REFEREE_TITLE_OPTIONS: {
        PROF: 'Prof',
        DR: 'Dr',
        MR: 'Mr',
        MS: 'Ms',
        MRS: 'Mrs',
        MISS: 'Miss',
        SIR: 'Sir',
        MADAM: 'Madam',
        OTHERS: 'Others',
      },
      SURNAME: 'Surname',
      GIVEN_NAME: 'Given Name',
      INSTITUTION: 'Name of Institution/Organization',
      POSITION: 'Position',
      RELATIONSHIP: 'Relationship',
      EMAIL: 'Email of Institution/Organization',
      PHONE_NUMBER: 'Phone Number (Area Code - Phone Number)',
      FAX_NUMBER: 'Fax Number',
      FILES_PANEL: {
        PANEL_TITLE: 'Academic Referee - Files Upload',
        PANEL_CAPTION: 'Supporting documents',
      },
      ADD_MORE_FORM: 'Add More Academic Referees',
    },
    PROFESSIONAL_QUALIFICATION: {
      TITLE: 'Professional Qualification',
      AWARD_DATE: 'Award Date',
      COUNTRY: 'Country/Region',
      FIELD_OF_PROFESSION: 'Field of Profession',
      PROFESSIONAL_QUALIFICATION: 'Professional Qualification',
      AWARD_NAME: 'Award Name',
      NAME_OF_AWARD_BODY: 'Name of Awarding Body',
      OTHER_AWARD_BODY_NAME: 'For other awarding body, please specify here',
      MEANS_OF_ATTAINMENT: 'Means of Attainment',
      ADD_MORE_PROFESSIONAL_QUALIFICATION_FORM:
        'Add More Professional Qualifications',
      OPTIONS_LABEL: {
        PROFESSIONAL_QUALIFICATION_PROFESSIONAL_FIELD: {
          ACCOUNTING_AUDITING: 'Accounting / Auditing',
          ARCHITECTURE_SURVEYING: 'Architecture / Surveying',
          ADVERTISING_MARKETING: 'Advertising / Marketing',
          BANKING_FINANCE: 'Banking / Finance',
          BIOTECHNOLOGY_CHEMICALS: 'Biotechnology / Chemicals',
          BUILDING_CONSTRUCTION: 'Building / Construction',
          CIVIL_AND_SOCIAL_SERVICES: 'Civil and Social Services',
          COMMUNICATION_PUBLIC_RELATIONS: 'Communication / Public Relations',
          DESIGN: 'Design',
          EDUCATION: 'Education',
          ENGINEERING: 'Engineering',
          HEALTH_CARE: 'Health Care',
          HOTEL_CATERING: 'Hotel / Catering',
          INFORMATION_TECHNOLOGY: 'Information Technology',
          INSURANCE: 'Insurance',
          LEGAL: 'Legal',
          LOGISTICS_TRANSPORT: 'Logistics / Transport',
          MANUFACTURING: 'Manufacturing',
          MEDIA: 'Media',
          MERCHANDISING_TRADING: 'Merchandising / Trading',
          PRINTING_PUBLISHING: 'Printing / Publishing',
          PUBLIC_UTILITIES: 'Public Utilities',
          REAL_ESTATE: 'Real Estate',
          TELECOMMUNICATIONS: 'Telecommunications',
          TEXTILES_AND_GARMENTS: 'Textiles and Garments',
          TOURISM_TRAVEL: 'Tourism / Travel',
          WHOLESALE_AND_RETAIL: 'Wholesale and Retail',
          OTHERS: 'Others',
        },
        PROFESSIONAL_QUALIFICATION_PROFESSIONAL_QUALIFICATION: {
          AFFILIATE: 'Affiliate',
          APPRENTICE_CRAFT_CERTIFICATE: 'Apprentice/Craft Certificate',
          CERTIFICATE_OF_COMPETENCE: 'Certificate of Competence',
          CERTIFICATE_OF_REGISTRATION: 'Certificate of Registration',
          CHARTERED_QUALIFIED_REGISTERED_PROFESSIONAL:
            'Chartered/Qualified/Registered Professional',
          COMPANION: 'Companion',
          FELLOW: 'Fellow (incl. all types of fellowship)Incorporate Engineer',
          LICENTIATE: 'Licentiate',
          MEMBER: 'Member (incl. all types of membership)',
          PASS_ENGG_COUNCIL_I: 'Pass Engg Council l',
          PASS_ENGG_COUNCIL_II: 'Pass Engg Council ll',
          PROBATIONARY_MEMBER: 'Probationary Member',
          PROFESSIONAL_ASSOCIATE: 'Prof Associate',
          REGISTERED_CHINESE_MEDICINE_PRACTITIONER:
            'Reg. Chinese Medicine Practitioner',
          TECHNICIAN: 'Technician',
          TEACH_INSTRUCT_QUA: 'Teach./Instruct Qua',
          SEC_TECHNICAL_SKILL: 'Sec./Technical Skill',
        },
        PROFESSIONAL_QUALIFICATION_AWARD_BODY: {
          INTERNATIONAL_SOCIETY_FOR_PROSTHETICS_AND_ORTHOTICS:
            'International Society for Prosthetics and Orthotics',
          OCCUPATIONAL_THERAPISTS_BOARD_HONG_KONG:
            'Occupational Therapists Board, Hong Kong',
          PHYSIOTHERAPISTS_BOARD_HONG_KONG: 'Physiotherapists Board, Hong Kong',
          HONG_KONG_SOCIETY_OF_CERTIFIED_PROSTHETIST_ORTHOTISTS:
            'Hong Kong Society of Certified Prosthetist-Orthotists',
          PHYSIOTHERAPY_BOARD_OF_NEW_ZEALAND:
            'Physiotherapy Board of New Zealand',
          HEALTH_PROFESSIONS_COUNCIL_HPC: 'Health Professions Council (HPC)',
          ALLIED_HEALTH_PROFESSIONAL_COUNCIL_SINGAPORE:
            'Allied Health Professional Council, Singapore',
          IRISH_SOCIETY_OF_CHARTERED_PHYSIOTHERAPISTS:
            'Irish Society of Chartered Physiotherapists',
          PHYSICAL_THERAPY_BOARD: 'Physical Therapy Board',
          THE_AUSTRALIAN_PHYSIOTHERAPY_COUNCIL:
            'The Australian Physiotherapy Council',
          CANADIAN_ALLIANCE_OF_PHYSIOTHERAPY_REGULATORS:
            'Canadian Alliance of Physiotherapy Regulators',
          AMERICAN_PHYSICAL_THERAPY_ASSOCIATION:
            'American Physical Therapy Association',
          NATIONAL_BOARD_FOR_CERTIFICATION_IN_OCCUPATIONAL_THERAPY:
            'National Board for Certification in Occupational Therapy',
          OCCUPATIONAL_THERAPY_BOARD_OF_AUSTRALIA:
            'Occupational Therapy Board of Australia',
          OTHERS: 'Others',
        },
      },
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Supporting document',
      },
    },
    CURRICULUM_VITAE: {
      TITLE: 'Curriculum Vitae',
      UPLOAD_CV: 'Please upload your Curriculum Vitae. ',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Curriculum Vitae',
      },
    },
    IDENTIFICATION_DOCUMENT: {
      TITLE: 'Identification Document',
      UPLOAD_ID:
        'Please upload your Identification Document which has been used for registering the account (for example, Mainland ID card, passport and Hong Kong Permanent ID card)',
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
      },
    },
    RESEARCH_PROPOSAL: {
      TITLE: 'Research Proposal',
      UPLOAD_RESEARCH_PROPOSAL: `Please upload your Research Proposal using the 
      <a
        href = 'https://www.polyu.edu.hk/gs/docdrive/forms/FormGSB1a.doc'
        target = '_blank'
      >template</a>. `,
      FILES_PANEL: {
        PANEL_TITLE: 'Files Upload',
        PANEL_CAPTION: 'Research Proposal',
      },
    },
  },
  ADDITIONAL_DOCUMENTS: {
    TITLE: 'Additional Documents',
    SUPPORTING_DOCUMENTS: 'Supporting Documents',
    CAPTION: 'Type of Documents',
    PERSONAL_STATEMENT: 'Personal Statement',
    DOCS_OPTIONS: {
      ADDITIONAL_REFERENCE_LETTER: 'Additional Reference Letter',
      OTHERS: 'Others',
    },
    FILES_PANEL: {
      PANEL_TITLE: 'Files Upload',
      PANEL_CAPTION: 'Supporting document',
    },
    ADD_MORE_DOCS: 'Add More Documents',
    UPLOAD_PERSONAL_STATEMENT: 'Please upload your Personal Statement. ',
  },
  DECLARATION: {
    TITLE: 'Declaration',
    CONFIRMATION:
      'I confirm that l read and understood the following relating to my personal data and information: *',
    INFORMATION_ACCURATE:
      'I declare that the information given in support of this application is accurate and complete. l understand that any misrepresentation will lead to disqualification of my application for admission to and registration with The Hong Kong Polytechnic University(PolyU). Making, submitting or using any false instrument (including forged documents) are serious criminal offenses involving dishonesty under the Crimes Ordinance (Cap.200, Laws of Hong Kong), punishable by imprisonment The University will refer any instances of suspected admission fraud matters to the police, The University reserves the right to take other actions. *',
    ENGAGEMENT:
      'Have you engaged an education agent to assist you with your application? *',
    MAINLAND_INFO: `
      for applicant from mainland China, [<a  
      href="https://www.polyu.edu.hk/aradm/eadmission/PICS_for_PRC_applicant.pdf"
      target="_blank"
      >Personal information Collection Statement for Applicant fromPeople's Republic of China</a>]`,
    EU_INFO: `
      for applicant from EU country, [<a  
      href="https://www.polyu.edu.hk/aradm/eadmission/Notice_for_Applicant_from_the_EEA.pdf"
      target="_blank"
      >Notice for Application from the European Area</a>]`,
    OTHERS_INFO: `
      for applicant from Hong Kong or other country/region, [<a  
      href="https://www.polyu.edu.hk/aradm/eadmission/PICS_applicant.pdf"
      target="_blank"
      >Personal information Collection Statement for Applicants</a>]`,
  },
  PROOF_DOCUMENT: {
    TITLE: 'Proof Document',
    CAPTION: 'Document Security Type',
    PUBLIC_EXPLANATION:
      'Public: The document can be displayed to all user roles including applicant. ',
    INTERNAL_EXPLANATION:
      'Internal: The document can be displayed to all internal user roles. ',
    RESTRICT_EXPLANATION:
      'Restricted: The document can only be displayed to central user role (AR and GS). ',
  },
  SUBMIT_CONFIRM: {
    KEY: 'SUBMIT',
    TITLE: 'Are you sure to submit this application?',
    CONTENT: 'Once you submit this application, no revisions will be allowed.',
    CONFIRM_CLEAR_FUNDING:
      'The application deadline for HKPFS and Distinctive Scholarship has passed. If you proceed with submission, your HKPFS Reference Number and Distinctive Scholarship Priority will be cleared. Are you sure you want to submit the application?',
  },
  LAST_SEND_DATE: 'Email Last Sent Time: ',
  REFEREE_EXPIRED: "The referee's report has expired. ",
  REFEREE_SUBMITTED: "The referee's report has been submitted.",
  EXPIRED_DATE: 'Email Expired Time: ',
  REPLIED_DATE: 'Email Replied Time: ',
  CONDITION_SAVE_ALTER_TEXT:
    "Your updates have been successfully saved. To ensure your offer is not affected, please revisit the 'Application Progress - Register Preparation - Meet Condition' section and confirm all updates after making any changes. If confirmation is not provided, your conditions may be marked as unmet, potentially impacting your offer.",
  NO_INFORMATION_SUBMITTED: 'No Form Information Submitted.',
  ADD: 'Add',
  REMOVE: 'Remove',
  SAVE: 'Save',
  CREATE: 'Create Application',
  SUBMIT: 'Submit',
  PREVIEW: 'Preview & Submit',
  DELETE: 'Delete',
  DELETE_CONFIRM: 'Are you sure you want to delete the item?',
  CONVERT: 'Calculate',
  BACK: 'Back',
  CONVERT_APPLY: 'Calculate & Apply',
  CALCULATE: 'Calculate',
  CALCULATE_APPLY: 'Calculate & Apply',
  APPLY: 'Apply',
  CONFIRM: 'Confirm',
  YES: 'Yes',
  WITHDRAW: 'Withdraw',
  CANCEL: 'Cancel',
  BACK_TO_CHECK: 'Back to Check',
  GO_SUBMIT: 'Go Submit',
  CLOSE: 'Close',
  FILES_UPLOAD: 'Files Upload',
  WITHDRAW_CONFIRM: {
    TITLE: 'Are you sure you want to withdraw from this application?',
    CONTENT:
      'By withdrawing, you will lose all progress and your application will be canceled. This action cannot be reversed and your application fee will not be refunded.',
  },
  VALIDATION_SUBMIT: {
    KEY: 'VALIDATION',
    PROVIDE_ACADEMIC_QUALIFICATION:
      'Please provide at least one Academic Qualification with related documents',
    PROVIDE_LANGUAGE_QUALIFICATION:
      'Please finish Language Qualification with related documents',
    PROVIDE_RESEARCH_PROPOSAL: 'Please upload Research Proposal Document',
    PROVIDE_CURRICULUM_VITAE: 'Please upload Curriculum Vitae Document',
    PROVIDE_IDENTIFICATION_DOCUMENT: 'Please upload Identification Document',
    PROVIDE_PERSONAL_STATEMENT: 'Please upload Personal Statement Document',
    PROVIDE_GSB_J4:
      'Please upload the Study Plan for the Dual PhD Degree and Joint PhD Supervision Programmes Leading to a PolyU Degree (GSB/J4)',
    PROVIDE_RESEARCH_EXPERIENCE:
      'Please complete the Research Experience section',
    PROVIDE_ACADEMIC_REFEREE_1: 'Please provide at least one Academic Referees',
    PROVIDE_ACADEMIC_REFEREE_2: 'Please provide at least two Academic Referees',
    SUBMIT_SUCCESS:
      'You will be directed to complete the payment for the application fee.',
    RE_SUBMIT_SUCCESS: 'Application Resubmitted Successfully. ',
    DECLARATION:
      'Please make sure you have completed the “Declaration” section before submitting your application. ',
  },
  CREATE_APPLICATION_SUCCESS: 'Application Created Successfully',
  SEND_INFORMING_EMAIL: 'Send Invitation Email',
  MAKE_UP_DECLARATION: {
    SAVE_AND_SUBMIT: 'Save & Submit',
    NOT_COMPLETE_WARNING:
      'Please make sure you have completed the Declaration form.',
    SUCCESSFUL_ALERT: 'Saved and Submitted Successfully',
  },
  // TODO: May update the text to view as applicant in the future but still not sure
  VIEW_MODE: 'View Mode',
  EDIT_MODE: 'Edit Mode',
  DISABLED_BUTTON_TOOLTIPS: 'The button can only be operated by the applicant.',
};
